<template>
  <div class="home-container1">
    <header data-role="Header" class="home-navbar-container">
      <Navbar />
    </header>
    <div class="historie-section-separator1"></div>
    <div class="historie-section-separator2"></div>
    <div class="historie-container3">
      <div class="historie-features">
        <h1 class="historie-text10">Historie</h1>
        <span class="historie-text11">
          <span>
            Theo Brandt is al ruim {{ yearsOfExperience }} jaar werkzaam in het
            glas. Begonnen als timmerman na de middelbare school en sinds
            {{ startedAsFreelancer }} jaar werkt hij zelfstandig als glaszetter.
            Als glaszetter kwam hij in aanraking met glas-in-lood, wat direct
            zijn interesse wekte. {{ cursusBegin }} jaar geleden volgde hij een
            cursus en sindsdien maakt hij prachtige glas-in-lood ramen voor
            particulieren en bedrijven. Daarnaast kan hij ook brandschilderen.
            Gebrandschilderde familie-wapens of gemeente-wapens komen goed tot
            hun recht in een glas-in-lood raam. De timmersmanswerkzaamheden kan
            je prima combineren met het glaszetten en het glas-in-lood. Ook is
            hij gespecialiseerd in het inbouwen van glas-in-lood paneel in
            spouwglas.
          </span>
          <br />
          <br />
          <span>
            In zijn atelier bevinden zich ruim voldoende glassoorten in alle
            kleuren en voorbeelden (foto`s, tekeningen e.d.) om een glas-in-lood
            raam te kunnen ontwerpen geheel naar de wens van de klant. Het
            glas-in-lood raam kan gebrandschilderde elementen omvatten. Ook
            hiervan zijn genoeg voorbeelden en ideeën te vinden in het atelier.
            <span v-html="raw2k38"></span>
          </span>
          <span><span v-html="rawrdvu"></span></span>
        </span>
      </div>
    </div>
    <div class="historie-container4">
      <div class="historie-testimonial1">
        <img
          alt="image"
          src="/homepagineeerstefoto-300w.png"
          class="historie-image"
        />
        <div class="historie-testimonial2">
          <div class="historie-container5">
            <svg viewBox="0 0 950.8571428571428 1024" class="historie-icon14">
              <path
                d="M438.857 548.571v219.429c0 60.571-49.143 109.714-109.714 109.714h-219.429c-60.571 0-109.714-49.143-109.714-109.714v-402.286c0-161.143 131.429-292.571 292.571-292.571h36.571c20 0 36.571 16.571 36.571 36.571v73.143c0 20-16.571 36.571-36.571 36.571h-36.571c-80.571 0-146.286 65.714-146.286 146.286v18.286c0 30.286 24.571 54.857 54.857 54.857h128c60.571 0 109.714 49.143 109.714 109.714zM950.857 548.571v219.429c0 60.571-49.143 109.714-109.714 109.714h-219.429c-60.571 0-109.714-49.143-109.714-109.714v-402.286c0-161.143 131.429-292.571 292.571-292.571h36.571c20 0 36.571 16.571 36.571 36.571v73.143c0 20-16.571 36.571-36.571 36.571h-36.571c-80.571 0-146.286 65.714-146.286 146.286v18.286c0 30.286 24.571 54.857 54.857 54.857h128c60.571 0 109.714 49.143 109.714 109.714z"
              ></path>
            </svg>
          </div>
          <span class="historie-text17">
            <span>
              Ik hou niet van stillzitten en ik ben van plan om de rest van mijn
              leven door te gaan met het maken en zetten van glas. Ik hou er van
              om mensen blij te maken met hun ontwerpen tot leven brengen.
            </span>
            <br />
          </span>
          <div class="historie-container6">
            <svg viewBox="0 0 950.8571428571428 1024" class="historie-icon16">
              <path
                d="M438.857 182.857v402.286c0 161.143-131.429 292.571-292.571 292.571h-36.571c-20 0-36.571-16.571-36.571-36.571v-73.143c0-20 16.571-36.571 36.571-36.571h36.571c80.571 0 146.286-65.714 146.286-146.286v-18.286c0-30.286-24.571-54.857-54.857-54.857h-128c-60.571 0-109.714-49.143-109.714-109.714v-219.429c0-60.571 49.143-109.714 109.714-109.714h219.429c60.571 0 109.714 49.143 109.714 109.714zM950.857 182.857v402.286c0 161.143-131.429 292.571-292.571 292.571h-36.571c-20 0-36.571-16.571-36.571-36.571v-73.143c0-20 16.571-36.571 36.571-36.571h36.571c80.571 0 146.286-65.714 146.286-146.286v-18.286c0-30.286-24.571-54.857-54.857-54.857h-128c-60.571 0-109.714-49.143-109.714-109.714v-219.429c0-60.571 49.143-109.714 109.714-109.714h219.429c60.571 0 109.714 49.143 109.714 109.714z"
              ></path>
            </svg>
          </div>
        </div>
        <span class="historie-text20">Theo Brandt</span>
        <span class="historie-text21">Glaszetter &amp; Glaskunstenaar</span>
      </div>
    </div>
    <div class="historie-section-separator6"></div>
    <div class="historie-section-separator7"></div>
    <div class="historie-footer-container">
      <Footer />
    </div>
  </div>
</template>

<script>
import FotoMetTekst from "../components/foto-met-tekst";
import Navbar from "../components/navbar";
import Footer from "../components/footer";

export default {
  name: "Historie",
  props: {},
  components: {
    FotoMetTekst,
    Navbar,
    Footer,
  },
  data() {
    return {
      raw2k38: " ",
      rawrdvu: " ",
      baseYear: 2024,
      baseNumber: 35,
    };
  },
  metaInfo: {
    title: "Historie - Langglas",
    meta: [
      {
        property: "og:title",
        content: "Historie - Langglas",
      },
    ],
  },
  computed: {
    yearsOfExperience() {
      const currentYear = new Date().getFullYear();
      return this.baseNumber + (currentYear - this.baseYear);
    },

    startedAsFreelancer() {
      return this.yearsOfExperience - 3;
    },

    cursusBegin() {
      return this.yearsOfExperience - 8;
    },
  },
};
</script>

<style scoped>
.historie-section-separator6 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.historie-section-separator7 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.home-container1 {
  width: 100%;
  height: auto;
  display: flex;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
}
.home-navbar-container {
  top: 0px;
  left: 0px;
  width: 100%;
  display: flex;
  z-index: 100;
  position: absolute;
  box-shadow: 5px 5px 10px 0px #d4d4d4;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #f5ff1c;
}
.home-navbar {
  width: 1550px;
  display: flex;
  max-width: auto;
  align-items: center;
  padding-top: var(--dl-space-space-tripleunit);
  padding-left: var(--dl-space-space-tripleunit);
  padding-right: var(--dl-space-space-tripleunit);
  flex-direction: row;
  padding-bottom: var(--dl-space-space-tripleunit);
}
.historie-heading1 {
  color: #000000;
  margin-right: var(--dl-space-space-doubleunit);
  text-decoration: none;
}
.historie-links-container1 {
  width: auto;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.historie-link10 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.historie-link11 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.historie-link12 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.historie-link13 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.historie-link14 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.historie-link15 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.historie-burger-menu {
  display: none;
  align-items: flex-start;
  flex-direction: column;
}
.historie-icon10 {
  width: 36px;
  height: 36px;
}
.historie-mobile-menu {
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100vh;
  display: none;
  padding: var(--dl-space-space-tripleunit);
  position: absolute;
  align-items: flex-start;
  flex-direction: column;
  background-color: #fff;
}
.historie-container2 {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: var(--dl-space-space-doubleunit);
  flex-direction: row;
  justify-content: space-between;
}
.historie-close-menu {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.historie-icon12 {
  width: 24px;
  height: 24px;
}
.historie-links-container2 {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.historie-link16 {
  margin-bottom: var(--dl-space-space-unit);
}
.historie-link17 {
  margin-bottom: var(--dl-space-space-unit);
}
.historie-link18 {
  margin-bottom: var(--dl-space-space-unit);
}
.historie-section-separator1 {
  width: 100%;
  height: 1px;
  display: flex;
  margin-top: var(--dl-space-space-tenunits);
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.historie-section-separator2 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.historie-container3 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #f1f1f1;
}
.historie-features {
  width: 100%;
  display: flex;
  padding: 48px;
  max-width: 1400px;
  flex-direction: column;
}
.historie-text10 {
  font-size: 3rem;
  margin-bottom: var(--dl-space-space-unit);
}
.historie-text11 {
  font-size: 18px;
  max-width: 1400px;
  align-self: flex-start;
  margin-top: var(--dl-space-space-halfunit);
  text-align: left;
  margin-bottom: var(--dl-space-space-halfunit);
}
.historie-container4 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #f1f1f1;
}
.historie-testimonial1 {
  width: 100%;
  height: 743px;
  display: flex;
  max-width: 1400px;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
}
.historie-image {
  width: 288px;
  height: 288px;
  object-fit: cover;
  border-radius: var(--dl-radius-radius-round);
}
.historie-testimonial2 {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
}
.historie-container5 {
  display: flex;
  align-self: flex-start;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
}
.historie-icon14 {
  width: 48px;
  margin-bottom: -6rem;
}
.historie-text17 {
  font-size: 1.15rem;
  max-width: 600px;
  margin-top: 48px;
  text-align: center;
  padding-left: 32px;
  margin-bottom: 48px;
  padding-right: 32px;
}
.historie-container6 {
  display: flex;
  align-self: flex-end;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
}
.historie-icon16 {
  width: 48px;
  margin-top: -6rem;
}
.historie-text20 {
  font-size: 1.5rem;
  max-width: 600px;
  text-align: center;
  font-weight: 600;
  margin-bottom: var(--dl-space-space-halfunit);
}
.historie-text21 {
  color: var(--dl-color-gray-500);
  max-width: 600px;
  font-style: normal;
  text-align: center;
  font-weight: 500;
}
.historie-gallery {
  width: 100%;
  display: flex;
  max-width: 1400px;
  align-items: center;
  padding-top: 32px;
  padding-left: 48px;
  padding-right: 48px;
  flex-direction: column;
  padding-bottom: 32px;
}
.historie-text22 {
  font-size: 2.5rem;
  align-self: flex-start;
  text-align: center;
  margin-bottom: var(--dl-space-space-unit);
}
.historie-container7 {
  width: 100%;
  display: grid;
  grid-gap: var(--dl-space-space-unit);
  grid-template-columns: 1fr 1fr 1fr;
}
.historie-footer-container {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #e2e2e2;
  margin-top: auto;
}
.historie-footer {
  width: 100%;
  display: flex;
  max-width: var(--dl-size-size-maxcontent);
  align-items: center;
  padding-top: var(--dl-space-space-tripleunit);
  padding-left: var(--dl-space-space-tripleunit);
  padding-right: var(--dl-space-space-tripleunit);
  flex-direction: row;
  padding-bottom: var(--dl-space-space-tripleunit);
  justify-content: center;
}
.historie-copyright-container {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.historie-icon18 {
  width: 24px;
  height: 24px;
  margin-right: var(--dl-space-space-doubleunit);
}
@media (max-width: 1600px) {
  .historie-navbar {
    width: 90%;
  }
  .historie-footer {
    justify-content: center;
  }
}
@media (max-width: 1200px) {
  .historie-navbar {
    width: 100%;
  }
  .historie-heading1 {
    margin-right: var(--dl-space-space-fourunits);
  }
  .historie-links-container1 {
    width: auto;
    position: relative;
  }
  .historie-link10 {
    width: auto;
    height: auto;
  }
  .historie-link11 {
    width: auto;
    height: auto;
  }
  .historie-link12 {
    width: auto;
    height: auto;
  }
  .historie-link13 {
    width: auto;
    height: auto;
  }
  .historie-link14 {
    width: auto;
  }
  .historie-link15 {
    width: auto;
  }
}
@media (max-width: 991px) {
  .historie-heading1 {
    text-align: center;
  }
  .historie-links-container1 {
    width: 424px;
    display: none;
  }
  .historie-link10 {
    width: auto;
    height: auto;
  }
  .historie-link11 {
    width: auto;
    height: auto;
  }
  .historie-link12 {
    width: auto;
    height: auto;
  }
  .historie-link13 {
    width: auto;
    height: auto;
  }
  .historie-link14 {
    width: auto;
    height: auto;
  }
  .historie-link15 {
    width: auto;
    height: auto;
  }
  .historie-burger-menu {
    display: flex;
  }
  .historie-heading2 {
    text-align: center;
  }
  .historie-text11 {
    max-width: 100%;
  }
  .historie-image {
    margin-bottom: 0px;
  }
  .historie-text17 {
    margin-top: 48px;
    margin-bottom: 48px;
  }
  .historie-container7 {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
@media (max-width: 767px) {
  .historie-navbar {
    position: relative;
  }
  .historie-links-container1 {
    display: none;
  }
  .historie-burger-menu {
    display: flex;
    padding: var(--dl-space-space-halfunit);
    margin-left: var(--dl-space-space-tripleunit);
    border-radius: var(--dl-radius-radius-radius4);
    background-color: var(--dl-color-gray-black);
  }
  .historie-icon10 {
    fill: var(--dl-color-gray-white);
  }
  .historie-features {
    padding-left: 32px;
    padding-right: 32px;
  }
  .historie-text11 {
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
  }
  .historie-testimonial1 {
    padding-left: 32px;
    padding-right: 32px;
  }
  .historie-gallery {
    padding-left: 32px;
    padding-right: 32px;
  }
  .historie-container7 {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 479px) {
  .historie-burger-menu {
    margin-left: var(--dl-space-space-doubleunit);
  }
  .historie-features {
    padding-top: 32px;
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: 32px;
  }
  .historie-testimonial1 {
    padding-top: 32px;
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: 32px;
  }
  .historie-image {
    width: 200px;
  }
  .historie-icon14 {
    margin-bottom: 0px;
  }
  .historie-text17 {
    width: auto;
  }
  .historie-icon16 {
    margin-bottom: var(--dl-space-space-unit);
  }
  .historie-gallery {
    padding: var(--dl-space-space-unit);
  }
  .historie-container7 {
    grid-template-columns: 1fr;
  }
}
</style>
